<template>
<div class="center-box">
<dv-border-box-8>
<div class="center">
  <div class="title">物流金融</div>
  <div class="item-group">
    <div class="item" v-for="(item, index) in centerData" :key="index">
      <div>
        <div v-if="index < 4">平台</div>
        <div v-else>全年预估</div>
        <div>{{ item.name }}</div>
      </div>
      <div>
        <dv-digital-flop :config="{
              number: [item.value],
              toFixed: valuePlaces(index),
              textAlign: 'right',
              style: lineStyle
            }" 
            style="height: 68px" />
        {{ item.company }}
      </div>
    </div>
  </div>
</div>
</dv-border-box-8>
</div>
</template>

<script>
import { getLogisticsFinance } from '../../../api/colunm4'
import { center } from '../js/data'
export default {

  data () {
    return {
      centerData: center,
      timer: null,
      lineStyle: {
        fill: '#34DEE5',
        fontSize: 34,
        fontWeight: 'bold'
      }
    }
  },

  created() {
    this.getPageData()
  },

  methods: {
    getPageData() {
      getLogisticsFinance().then(res => {
        // this.centerData[0].value = res.aturnover
        // this.centerData[1].value = res.monthOnYearGrowth
        // this.centerData[2].value = res.numberoforders
        // this.centerData[3].value = res.creditAmount
        // this.centerData[4].value = res.numOfUpstreamEnterprises
        // this.centerData[5].value = res.numOfDownstreamMerchants
        this.centerData[0].value = res.aturnover
        this.centerData[1].value = res.monthOnYearGrowth
        this.centerData[2].value = res.numOfUpstreamEnterprises
        this.centerData[3].value = res.numOfDownstreamMerchants
        this.centerData[4].value = res.numberoforders
        this.centerData[5].value = res.creditAmount
        
        this.timer && clearInterval(this.timer)
        this.timer = setTimeout(this.getPageData, 1000 * 10)
      })
    },

    valuePlaces (index) {
      switch (index) {
        case 0:
          return 1
        case 1:
          return 1
        case 2:
          return 0
        case 3:
          return 0
        case 4: 
          return 0
        case 5:
          return 0
      }
    }
  }
}
</script>

<style lang="less" scoped>
.center-box {
  width: 648px;
  height: 301px;
}
.center {
  width: 648px;
  height: 301px;
  padding: 16px 22px 18px 18px;
  background: linear-gradient(-21deg, rgba(14, 49, 115, 0.5), rgba(7, 20, 73, 0.5));
  .title {
    width: 100%;
    height: 60px;
    color: #34DEE5;
    font-size: 30px;
    font-weight: bold;
    text-align: center;
    line-height: 60px;
  }
  .item-group {
    flex-grow: 1;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-content: space-between;
  }
  .item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 297px;
    height: 68px;
    padding: 0 17px 0 10px;
    border-radius: 12px;
    color: #FFFFFF;
    white-space: nowrap;
    font-weight: bold;
    background: linear-gradient(0deg, #07205B 0%, #060D34 100%);
    & > div:nth-child(1) {
      font-size: 17px;
    }
    & > div:nth-child(2) {
      flex-grow: 1;
      display: flex;
      justify-content: flex-end;
      align-items: center;
      font-size: 21px;
    }
  }
}
</style>